import api from '../token';

export const AddEstoque = async (estoque) => {
  try {
    const response = await api.post('/addEstoque', estoque);
    return response.data;
  } catch (error) {
    console.error('Erro ao adicionar estoque:', error);
    return { success: false, message: error.message };
  }
};


